import React, { useEffect } from 'react';
import mu1 from '../media/mu1.png';
import { useParams } from 'react-router-dom';

const blogs =[
  {
    "id": "1",
    "image": "media/mu1.png",
    "title": "The Science of Softness: Why Kidorise is Perfect for Your Baby",
    "paragraphs": [
      "When it comes to our little ones, comfort isn't just a luxury—it's an essential. And that's where the enchanting world of muslin steps in. If you've ever wondered why muslin seems to be a unanimous favorite in baby products, you're in for a treat. Let's uncover the science behind the softness and understand why muslin is the perfect match for your precious bundle of joy.",
      "The Feather-Light, Breathable Embrace: Imagine wrapping your baby in a soft cloud—well, that's pretty much how muslin feels against their delicate skin. Muslin's open-weave structure is designed to be lightweight and incredibly breathable, ensuring your baby's comfort no matter the weather. It's like a gentle hug that keeps them cozy without causing overheating—just what you need for a happy, content baby.",
      "Sensitive Skin's Best Friend: Babies have skin that's as delicate as a butterfly's wing, and that's where muslin swoops in as a hero. Its natural fibers are kind to even the most sensitive skin, reducing the risk of irritation and allergies. Say goodbye to scratchy materials and hello to a fabric that's as soothing as a lullaby.",
      "The Dance of Absorption and Release: Babies are known to be little magicians, turning diaper changes into surprise acts. Enter muslin, the trusty sidekick that wicks away moisture like a seasoned pro. Its unique ability to absorb and release moisture quickly keeps your baby's skin dry, making it perfect for swaddles, nappies, and all those little moments where comfort matters the most.",
      "Whispers of Tradition and Modernity: At Annasimona, we've embraced the legacy of muslin while infusing it with modern designs that capture the essence of your little one's journey. From swaddles to burp bibs, each product tells a story of softness and security. Our muslin blankets become cozy cocoons of dreams, while our playmats provide a world of exploration for those tiny toes. It's like wrapping your baby in timeless love, carefully woven into every thread.",
      "The journey into parenthood is filled with wonder, joy, and moments that take your breath away. With muslin by your side, these moments become even more magical. At Annasimona, we've curated a range of baby essentials that embrace the science of softness, ensuring your baby's comfort and your peace of mind. From swaddles to playmats, every product carries the whispers of care and craftsmanship, reminding you that the world you're creating for your baby is nothing short of extraordinary."
    ],
    "author": "Unknown"
  },
  {
    "id": "2",
    "image": "media/mu2.webp",
    "title": "Swaddling 101: A Parent’s Guide to Soothing Sleep",
    "paragraphs": [
      "Swaddling has been used for centuries, and for good reason. It helps newborns feel safe, secure, and sleep better.",
      "Muslin swaddles are perfect due to their breathability and gentle texture. They help prevent overheating while mimicking the snug environment of the womb.",
      "At Kidorise, our swaddles are designed with both tradition and modern needs in mind—beautiful patterns meet baby-safe fabric for the best of both worlds."
    ],
    "author": "Aarav Mehta"
  },
  {
    "id": "3",
    "image": "media/mu3.webp",
    "title": "The Magic of Milestones: Supporting Your Baby’s Development",
    "paragraphs": [
      "Every giggle, roll, and crawl is a milestone worth celebrating. The early months are crucial for your baby’s physical and mental growth.",
      "Our playmats and tummy time accessories are crafted to provide sensory stimulation while keeping comfort at the forefront.",
      "Give your little explorer the right tools for growth—soft, safe, and thoughtfully designed."
    ],
    "author": "Simran Kapoor"
  }
]

const SingleBlog = () => {
  const { id } = useParams();
  const blog = blogs.find(b => b.id === id);

  if (!blog) return <p>Blog not found</p>;

  return (
    <section style={{ padding: '2rem', lineHeight: '1.8', maxWidth: '900px', margin: '0 auto', marginTop: '10rem' }}>
      <div style={{textAlign:'center'}}>
        <img src={require(`../${blog.image}`)} alt="" style={{width:'50%'}} />
      </div>
      <p style={{ fontSize: '3rem', fontWeight: '500', marginBottom: '2rem', marginTop:'1.5rem', color: '#44413e' }}>{blog.title}</p>
      {blog.paragraphs.map((para, index) => (
        <p key={index} style={{marginBottom:'1rem'}}>{para}</p>
      ))}
      <p style={{ marginTop: '2rem', fontStyle: 'italic' }}>
        Author,<br />
        <strong>{blog.author}</strong><br />
      </p>
    </section>
  );
};

export default SingleBlog;